import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './PatientSpecificTab.module.css';
import { faTimesCircle, faHome, faNotesMedical, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { patientActions } from '_actions';
import { getDateMDYY } from '_helpers'
import { FotoButton, AlButton } from '_components';


class PatientSpecificTab extends React.Component {

    constructor() {
        super();
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose(event) {
        this.props.closeTab({ tabId: this.props.tab.id, ptno: this.props.tab.ptno, noteId: this.props.tab.noteId });
        event.stopPropagation();
    }


    getIcon() {
        if (this.props.loading) {
            return (<FontAwesomeIcon icon={faSpinner} pulse />);
        } else {
            switch (this.props.tab.type) {
                case 'HOME':
                    return (<FontAwesomeIcon icon={faHome} />);
                case 'IN':
                    return (<FontAwesomeIcon icon={faNotesMedical} />);
                case 'AL':
                    return (<AlButton size='extra-small' />);
                case 'PDF':
                    if (this.props.tab.noteSource === 1 || this.props.tab.noteSource === 2 || this.props.tab.noteSource === 4) {
                        return (<FontAwesomeIcon icon={faFilePdf} />);
                    }
                    else if (this.props.tab.noteSource === 3) {
                        return (<FotoButton size='extra-small' className={styles.foto_button} />);
                    }
                    break;
                default:
                    return (<FontAwesomeIcon icon={faHome} />);
            }
        }
    }



    render() {
        return (
            <span
                key={this.props.tab.id}
                className={styles.tab + ' ' + (this.props.selected ? styles.tab_selected : '')}
                onClick={() => this.props.setTabActive(this.props.tab.ptno, this.props.tab.id, this.props.refreshPdf)}>
                <span className={styles.tab_contents}>
                    <span className={styles.tab_contents_icon}>
                        {this.getIcon()}
                    </span>
                    <span
                        className={styles.tab_contents_name}
                        title={this.props.tabName}>
                        {this.props.tabName}
                    </span>
                    {this.props.tab.type !== 'HOME' &&
                        <span title="Close Tab" className={styles.close} onClick={this.handleClose}>
                            <FontAwesomeIcon icon={faTimesCircle} />
                        </span>
                    }
                </span>
            </span>

        )
    };
}

function mapStateToProps(state, ownprops) {
    var name = '';
    let loading = false;
    if (state.ui.patientTabs[ownprops.id].type === 'HOME') {
        name = 'Patient Home';
    } else if (state.ui.patientTabs[ownprops.id].type === 'AL') {
        let epno = parseInt(state.ui.patientTabs[ownprops.id].id.split("_")[1]);

        if (state.ui.al[epno] && state.ui.al[epno].loading) {
            name = 'Loading...';
            loading = true;
        } else {
            name = 'Activity Log';
        }
    } else {
        var noteId = state.ui.patientTabs[ownprops.id].noteId;
        // lookup the noteId in notes.ui.reducer to determine if loading
        if (state.ui.notes[noteId] && state.ui.notes[noteId].loading) {
            name = 'Loading...';
            loading = true;
        } else if (state.entities.cdv[noteId]) {
            // if not loading, build the name based on the note type, date and visit # (only certain note types)
            name = state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[noteId].noteType].MTABBREV;
            name += state.entities.cdv[noteId].dos ? ' - ' + getDateMDYY(state.entities.cdv[noteId].dos) : '';
            name += state.entities.cdv[noteId].visitNum > 0 ? ' (visit ' + state.entities.cdv[noteId].visitNum + ')' : '';

        }
        else if (state.entities.limberAssessments[noteId]) {
            name = 'Limber - ' + state.entities.limberAssessments[noteId].assessmentDisplayName + ' - ' + getDateMDYY(state.entities.limberAssessments[noteId].completedDate);
        }
    }

    var noteId = state.ui.patientTabs[ownprops.id].noteId;
    let selectedPatient = state.entities.cdv[noteId];
    let refreshPdf = true;

    if (state.ui.patientTabs[ownprops.id].type === "PDF" && state.ui.patientTabs[ownprops.id].noteSource === 1 && selectedPatient !== undefined && selectedPatient.status === 2) {
        refreshPdf = false;
    }

    return {
        refreshPdf,
        tab: state.ui.patientTabs[ownprops.id],
        loading,
        tabName: name
    };
}


function mapDispatchToProps(dispatch) {
    return {
        setTabActive: bindActionCreators(patientActions.setTabActive, dispatch),
        closeTab: bindActionCreators(patientActions.closeTab, dispatch)
    };
}

const connectedPatientSpecificTab = connect(mapStateToProps, mapDispatchToProps)(PatientSpecificTab);
export { connectedPatientSpecificTab as PatientSpecificTab };

